<template>
	<div class="landscape">
		<div class="layer-landscape far-mountains"></div>
		<div class="layer-landscape grass-mountains"></div>
		<div class="layer-landscape clouds-mid"></div>
		<div class="layer-landscape hill"></div>
		<div class="layer-landscape clouds-front"></div>
	</div>
</template>
<script>
export default {
	name: "Hill",
};
</script>
<style lang="scss" scoped>
.landscape {
	width: 100vw;
	height: 100vh;
	background: url("~@/assets/img/grassy/sky_fc.png");
	background-size: contain;
	image-rendering: pixelated;
	overflow: hidden;
	position: absolute;
	@media screen and (max-width: 768px) {
		background-size: cover;
	}
	.layer-landscape {
		position: absolute;
		height: 100%;
		width: 300%;
		filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.1));
		&.far-mountains {
			background: url("~@/assets/img/grassy/far_mountains_fc.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 50s linear infinite;
			z-index: 1;
		}
		&.grass-mountains {
			background: url("~@/assets/img/grassy/grassy_mountains_fc.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 38s linear infinite;
			z-index: 2;
		}
		&.clouds-mid {
			background: url("~@/assets/img/grassy/clouds_mid_fc.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 16s linear infinite;
			z-index: 3;
		}
		&.hill {
			background: url("~@/assets/img/grassy/hill.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: bump 3s ease-out infinite;
			z-index: 4;
		}
		&.clouds-front {
			background: url("~@/assets/img/grassy/clouds_front_fc.png");
			background-size: 33%;
			background-repeat: repeat-x;
			background-position: bottom;
			image-rendering: pixelated;
			animation: slide 12s linear infinite;
			animation-direction: reverse;
			z-index: 5;
		}
		&.paused {
			animation-play-state: paused;
		}
	}
}
@keyframes slide {
	0% {
		transform: translate(0);
	}
	100% {
		transform: translate(-33%);
	}
}
@keyframes bump {
	0% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(20px);
	}
	100% {
		transform: translateY(0);
	}
}
</style>
